var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMypropertlogo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 424,
    height: 212,
    viewBox: "0 0 424 212",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1511_63679)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 424,
    height: 212,
    rx: 20,
    fill: "#2E66C0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.085 117.104V113.465L182.775 108.514H184.157L185.851 111.104C186.163 111.588 186.454 112.072 186.724 112.557C186.982 112.107 187.294 111.602 187.661 111.039L189.325 108.514H190.65L187.222 113.465V117.104H186.085ZM190.04 113.992C190.04 112.84 190.361 111.986 191.001 111.432C191.536 110.971 192.189 110.74 192.958 110.74C193.814 110.74 194.513 111.021 195.056 111.584C195.599 112.143 195.87 112.916 195.87 113.904C195.87 114.705 195.749 115.336 195.507 115.797C195.269 116.254 194.919 116.609 194.458 116.863C194.001 117.117 193.501 117.244 192.958 117.244C192.087 117.244 191.382 116.965 190.843 116.406C190.308 115.848 190.04 115.043 190.04 113.992ZM191.124 113.992C191.124 114.789 191.298 115.387 191.646 115.785C191.993 116.18 192.431 116.377 192.958 116.377C193.482 116.377 193.917 116.178 194.265 115.779C194.613 115.381 194.786 114.773 194.786 113.957C194.786 113.188 194.611 112.605 194.259 112.211C193.911 111.812 193.478 111.613 192.958 111.613C192.431 111.613 191.993 111.811 191.646 112.205C191.298 112.6 191.124 113.195 191.124 113.992ZM201.191 117.104V116.189C200.706 116.893 200.048 117.244 199.216 117.244C198.849 117.244 198.505 117.174 198.185 117.033C197.868 116.893 197.632 116.717 197.476 116.506C197.323 116.291 197.216 116.029 197.154 115.721C197.111 115.514 197.089 115.186 197.089 114.736V110.881H198.144V114.332C198.144 114.883 198.165 115.254 198.208 115.445C198.275 115.723 198.415 115.941 198.63 116.102C198.845 116.258 199.111 116.336 199.427 116.336C199.743 116.336 200.04 116.256 200.318 116.096C200.595 115.932 200.79 115.711 200.904 115.434C201.021 115.152 201.079 114.746 201.079 114.215V110.881H202.134V117.104H201.191ZM208.105 117.104H207.126V108.514H208.181V111.578C208.626 111.02 209.195 110.74 209.886 110.74C210.269 110.74 210.63 110.818 210.97 110.975C211.314 111.127 211.595 111.344 211.814 111.625C212.036 111.902 212.21 112.238 212.335 112.633C212.46 113.027 212.523 113.449 212.523 113.898C212.523 114.965 212.259 115.789 211.732 116.371C211.204 116.953 210.572 117.244 209.833 117.244C209.099 117.244 208.523 116.938 208.105 116.324V117.104ZM208.093 113.945C208.093 114.691 208.195 115.23 208.398 115.562C208.73 116.105 209.179 116.377 209.745 116.377C210.206 116.377 210.605 116.178 210.941 115.779C211.277 115.377 211.445 114.779 211.445 113.986C211.445 113.174 211.282 112.574 210.958 112.188C210.638 111.801 210.249 111.607 209.792 111.607C209.331 111.607 208.933 111.809 208.597 112.211C208.261 112.609 208.093 113.188 208.093 113.945ZM217.89 117.104V116.189C217.405 116.893 216.747 117.244 215.915 117.244C215.548 117.244 215.204 117.174 214.884 117.033C214.568 116.893 214.331 116.717 214.175 116.506C214.023 116.291 213.915 116.029 213.853 115.721C213.81 115.514 213.788 115.186 213.788 114.736V110.881H214.843V114.332C214.843 114.883 214.864 115.254 214.907 115.445C214.974 115.723 215.114 115.941 215.329 116.102C215.544 116.258 215.81 116.336 216.126 116.336C216.443 116.336 216.739 116.256 217.017 116.096C217.294 115.932 217.489 115.711 217.603 115.434C217.72 115.152 217.779 114.746 217.779 114.215V110.881H218.833V117.104H217.89ZM220.445 119.5L220.327 118.51C220.558 118.572 220.759 118.604 220.931 118.604C221.165 118.604 221.353 118.564 221.493 118.486C221.634 118.408 221.749 118.299 221.839 118.158C221.905 118.053 222.013 117.791 222.161 117.373C222.181 117.314 222.212 117.229 222.255 117.115L219.894 110.881H221.03L222.325 114.484C222.493 114.941 222.644 115.422 222.777 115.926C222.898 115.441 223.042 114.969 223.21 114.508L224.54 110.881H225.595L223.228 117.209C222.974 117.893 222.777 118.363 222.636 118.621C222.448 118.969 222.234 119.223 221.991 119.383C221.749 119.547 221.46 119.629 221.124 119.629C220.921 119.629 220.695 119.586 220.445 119.5ZM225.876 117.104V115.902H227.077V117.104C227.077 117.545 226.999 117.9 226.843 118.17C226.687 118.443 226.439 118.654 226.099 118.803L225.806 118.352C226.029 118.254 226.193 118.109 226.298 117.918C226.404 117.73 226.462 117.459 226.474 117.104H225.876ZM233.429 117.104L231.525 110.881H232.614L233.605 114.473L233.974 115.809C233.989 115.742 234.097 115.314 234.296 114.525L235.286 110.881H236.37L237.302 114.49L237.613 115.68L237.97 114.479L239.036 110.881H240.062L238.116 117.104H237.021L236.03 113.377L235.79 112.316L234.53 117.104H233.429ZM245.212 115.1L246.302 115.234C246.13 115.871 245.812 116.365 245.347 116.717C244.882 117.068 244.288 117.244 243.566 117.244C242.655 117.244 241.933 116.965 241.398 116.406C240.866 115.844 240.601 115.057 240.601 114.045C240.601 112.998 240.87 112.186 241.409 111.607C241.948 111.029 242.648 110.74 243.507 110.74C244.339 110.74 245.019 111.023 245.546 111.59C246.073 112.156 246.337 112.953 246.337 113.98C246.337 114.043 246.335 114.137 246.331 114.262H241.691C241.73 114.945 241.923 115.469 242.271 115.832C242.618 116.195 243.052 116.377 243.572 116.377C243.958 116.377 244.288 116.275 244.562 116.072C244.835 115.869 245.052 115.545 245.212 115.1ZM241.749 113.395H245.224C245.177 112.871 245.044 112.479 244.825 112.217C244.489 111.811 244.054 111.607 243.519 111.607C243.034 111.607 242.626 111.77 242.294 112.094C241.966 112.418 241.784 112.852 241.749 113.395ZM255.032 114.824L256.07 114.959C255.956 115.674 255.665 116.234 255.197 116.641C254.732 117.043 254.159 117.244 253.48 117.244C252.628 117.244 251.943 116.967 251.423 116.412C250.907 115.854 250.65 115.055 250.65 114.016C250.65 113.344 250.761 112.756 250.984 112.252C251.206 111.748 251.544 111.371 251.997 111.121C252.454 110.867 252.95 110.74 253.486 110.74C254.161 110.74 254.714 110.912 255.144 111.256C255.573 111.596 255.849 112.08 255.97 112.709L254.945 112.867C254.847 112.449 254.673 112.135 254.423 111.924C254.177 111.713 253.878 111.607 253.527 111.607C252.995 111.607 252.564 111.799 252.232 112.182C251.9 112.561 251.734 113.162 251.734 113.986C251.734 114.822 251.894 115.43 252.214 115.809C252.534 116.188 252.952 116.377 253.468 116.377C253.882 116.377 254.228 116.25 254.505 115.996C254.782 115.742 254.958 115.352 255.032 114.824ZM261.032 116.336C260.642 116.668 260.265 116.902 259.902 117.039C259.542 117.176 259.155 117.244 258.741 117.244C258.058 117.244 257.532 117.078 257.165 116.746C256.798 116.41 256.614 115.982 256.614 115.463C256.614 115.158 256.683 114.881 256.82 114.631C256.96 114.377 257.142 114.174 257.364 114.021C257.591 113.869 257.845 113.754 258.126 113.676C258.333 113.621 258.646 113.568 259.064 113.518C259.915 113.416 260.542 113.295 260.945 113.154C260.948 113.01 260.95 112.918 260.95 112.879C260.95 112.449 260.851 112.146 260.652 111.971C260.382 111.732 259.982 111.613 259.45 111.613C258.954 111.613 258.587 111.701 258.349 111.877C258.114 112.049 257.941 112.355 257.827 112.797L256.796 112.656C256.89 112.215 257.044 111.859 257.259 111.59C257.474 111.316 257.784 111.107 258.191 110.963C258.597 110.814 259.068 110.74 259.603 110.74C260.134 110.74 260.566 110.803 260.898 110.928C261.23 111.053 261.474 111.211 261.63 111.402C261.786 111.59 261.896 111.828 261.958 112.117C261.993 112.297 262.011 112.621 262.011 113.09V114.496C262.011 115.477 262.032 116.098 262.075 116.359C262.122 116.617 262.212 116.865 262.345 117.104H261.243C261.134 116.885 261.064 116.629 261.032 116.336ZM260.945 113.98C260.562 114.137 259.988 114.27 259.222 114.379C258.788 114.441 258.482 114.512 258.302 114.59C258.122 114.668 257.984 114.783 257.886 114.936C257.788 115.084 257.739 115.25 257.739 115.434C257.739 115.715 257.845 115.949 258.056 116.137C258.271 116.324 258.583 116.418 258.993 116.418C259.4 116.418 259.761 116.33 260.077 116.154C260.394 115.975 260.626 115.73 260.775 115.422C260.888 115.184 260.945 114.832 260.945 114.367V113.98ZM263.64 117.104V110.881H264.589V111.824C264.831 111.383 265.054 111.092 265.257 110.951C265.464 110.811 265.691 110.74 265.937 110.74C266.292 110.74 266.654 110.854 267.021 111.08L266.657 112.059C266.4 111.906 266.142 111.83 265.884 111.83C265.654 111.83 265.447 111.9 265.263 112.041C265.079 112.178 264.948 112.369 264.87 112.615C264.753 112.99 264.695 113.4 264.695 113.846V117.104H263.64ZM271.907 115.1L272.997 115.234C272.825 115.871 272.507 116.365 272.042 116.717C271.577 117.068 270.984 117.244 270.261 117.244C269.351 117.244 268.628 116.965 268.093 116.406C267.562 115.844 267.296 115.057 267.296 114.045C267.296 112.998 267.566 112.186 268.105 111.607C268.644 111.029 269.343 110.74 270.202 110.74C271.034 110.74 271.714 111.023 272.241 111.59C272.769 112.156 273.032 112.953 273.032 113.98C273.032 114.043 273.03 114.137 273.027 114.262H268.386C268.425 114.945 268.618 115.469 268.966 115.832C269.314 116.195 269.747 116.377 270.267 116.377C270.654 116.377 270.984 116.275 271.257 116.072C271.53 115.869 271.747 115.545 271.907 115.1ZM268.445 113.395H271.919C271.872 112.871 271.739 112.479 271.521 112.217C271.185 111.811 270.749 111.607 270.214 111.607C269.73 111.607 269.322 111.77 268.989 112.094C268.661 112.418 268.48 112.852 268.445 113.395Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1511_63679)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M365.584 66.2744H316.493C311.846 66.2744 308.078 70.076 308.078 74.7654V93.1627C308.078 97.8522 311.846 101.654 316.493 101.654H365.584C370.232 101.654 374 97.8522 374 93.1627V74.7654C374 70.076 370.232 66.2744 365.584 66.2744Z",
    fill: "#FFAA15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.441 74.0575C316.41 74.0575 317.195 73.2655 317.195 72.2885C317.195 71.3115 316.41 70.5195 315.441 70.5195C314.473 70.5195 313.688 71.3115 313.688 72.2885C313.688 73.2655 314.473 74.0575 315.441 74.0575Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.0649 120.759C104.431 120.759 120.13 104.919 120.13 85.3793C120.13 65.8399 104.431 50 85.0649 50C65.6991 50 50 65.8399 50 85.3793C50 104.919 65.6991 120.759 85.0649 120.759Z",
    fill: "#FFAA15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.5211 80.9043H118.677L88.1958 104.485H57.7142L89.5211 80.9043Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.201 80.9043L103.961 92.6945L116.551 101.865H147.032L119.201 80.9043Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.2441 79.0107H86.8706V89.4909H80.2441V79.0107Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.436 78.0953V80.4728C157.281 78.7689 158.685 77.917 160.648 77.917C162.828 77.917 164.242 78.868 164.89 80.77C165.282 79.8586 165.871 79.1553 166.657 78.66C167.442 78.1646 168.336 77.917 169.337 77.917C170.849 77.917 172.018 78.3826 172.842 79.3138C173.667 80.2251 174.079 81.5328 174.079 83.2366V93.1626H170.515V83.9202C170.515 81.8993 169.75 80.8889 168.218 80.8889C167.452 80.8889 166.765 81.2257 166.156 81.8993C165.567 82.5729 165.273 83.6329 165.273 85.0792V93.1626H161.709V83.9202C161.709 81.8993 160.943 80.8889 159.411 80.8889C158.645 80.8889 157.958 81.2257 157.349 81.8993C156.741 82.5729 156.436 83.6329 156.436 85.0792V93.1626H152.902V78.0953H156.436Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.878 92.8659L175.987 78.0957H179.904L181.642 82.9101C182.172 84.3366 182.595 85.5353 182.909 86.5061C183.243 87.4769 183.449 88.0911 183.527 88.3486L183.616 88.7647C183.812 88.0713 184.44 86.1197 185.501 82.9101L187.062 78.0957H190.773L185.383 92.747C183.891 96.7689 181.613 98.7799 178.549 98.7799C177.98 98.7799 177.489 98.7303 177.077 98.6313V95.6891C177.391 95.7684 177.725 95.808 178.078 95.808C179.865 95.808 181.132 94.8273 181.878 92.8659Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.187 90.3101C201.248 90.3101 202.112 89.9039 202.779 89.0916C203.447 88.2595 203.781 87.1005 203.781 85.6145C203.781 84.1286 203.447 82.9795 202.779 82.1672C202.112 81.3351 201.267 80.919 200.246 80.919C199.225 80.919 198.342 81.3053 197.595 82.078C196.849 82.8507 196.476 83.9998 196.476 85.5254C196.476 87.0509 196.839 88.2298 197.566 89.0619C198.292 89.894 199.166 90.3101 200.187 90.3101ZM196.476 78.0957V80.4138C197.536 78.7297 199.058 77.8877 201.042 77.8877C202.986 77.8877 204.527 78.591 205.666 79.9977C206.824 81.4044 207.404 83.2569 207.404 85.5551C207.404 87.8137 206.824 89.686 205.666 91.1719C204.527 92.638 202.976 93.3711 201.012 93.3711C199.009 93.3711 197.497 92.5489 196.476 90.9045V98.8393H192.942V78.0957H196.476Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.964 78.0954V80.7701C214.652 78.9077 215.908 77.9766 217.735 77.9766C218.147 77.9766 218.481 78.0063 218.736 78.0657V81.5131C218.284 81.315 217.784 81.2159 217.234 81.2159C216.272 81.2159 215.486 81.6121 214.877 82.4046C214.269 83.1971 213.964 84.1878 213.964 85.3765V93.1628H210.4L210.43 78.0954H213.964Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.206 93.4003C224.947 93.4003 223.18 92.687 221.904 91.2605C220.647 89.834 220.019 88.0113 220.019 85.7923C220.019 83.4941 220.676 81.602 221.992 80.116C223.308 78.6103 225.046 77.8574 227.206 77.8574C229.503 77.8574 231.28 78.5905 232.537 80.0566C233.794 81.5029 234.422 83.3455 234.422 85.5843C234.422 87.8627 233.784 89.735 232.507 91.2011C231.251 92.6672 229.483 93.4003 227.206 93.4003ZM227.206 80.7698C226.086 80.7698 225.222 81.2354 224.614 82.1666C224.024 83.0978 223.73 84.2667 223.73 85.6734C223.73 87.0603 224.034 88.2193 224.643 89.1505C225.252 90.0817 226.116 90.5473 227.235 90.5473C228.394 90.5473 229.267 90.0916 229.856 89.1802C230.446 88.2688 230.74 87.1098 230.74 85.7031C230.74 84.2568 230.455 83.078 229.886 82.1666C229.316 81.2354 228.423 80.7698 227.206 80.7698Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.714 90.3101C245.775 90.3101 246.639 89.9039 247.306 89.0916C247.974 88.2595 248.308 87.1005 248.308 85.6145C248.308 84.1286 247.974 82.9795 247.306 82.1672C246.639 81.3351 245.794 80.919 244.773 80.919C243.752 80.919 242.868 81.3053 242.122 82.078C241.376 82.8507 241.003 83.9998 241.003 85.5254C241.003 87.0509 241.366 88.2298 242.093 89.0619C242.819 89.894 243.693 90.3101 244.714 90.3101ZM241.003 78.0957V80.4138C242.063 78.7297 243.585 77.8877 245.568 77.8877C247.512 77.8877 249.054 78.591 250.193 79.9977C251.351 81.4044 251.931 83.2569 251.931 85.5551C251.931 87.8137 251.351 89.686 250.193 91.1719C249.054 92.638 247.503 93.3711 245.539 93.3711C243.536 93.3711 242.024 92.5489 241.003 90.9045V98.8393H237.468V78.0957H241.003Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.94 84.3962V83.9504C263.901 82.9796 263.636 82.2069 263.145 81.6324C262.674 81.038 261.977 80.7408 261.054 80.7408C260.209 80.7408 259.473 81.0578 258.845 81.6918C258.236 82.306 257.843 83.2075 257.666 84.3962H263.94ZM266.356 89.2403V92.3311C265.315 92.9849 263.813 93.3118 261.849 93.3118C259.473 93.3118 257.598 92.5985 256.223 91.1721C254.849 89.7456 254.161 87.903 254.161 85.6444C254.161 83.2471 254.809 81.3649 256.105 79.9979C257.401 78.6308 259.021 77.9473 260.965 77.9473C262.909 77.9473 264.451 78.5416 265.59 79.7304C266.729 80.9191 267.298 82.6527 267.298 84.9311C267.298 85.4859 267.229 86.1991 267.092 87.0709H257.725C257.981 88.1606 258.511 88.9927 259.316 89.5672C260.141 90.1418 261.162 90.4291 262.379 90.4291C263.95 90.4291 265.276 90.0328 266.356 89.2403Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.082 78.0954V80.7701C274.769 78.9077 276.026 77.9766 277.852 77.9766C278.264 77.9766 278.598 78.0063 278.853 78.0657V81.5131C278.402 81.315 277.901 81.2159 277.351 81.2159C276.389 81.2159 275.604 81.6121 274.995 82.4046C274.386 83.1971 274.082 84.1878 274.082 85.3765V93.1628H270.518L270.547 78.0954H274.082Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.232 80.7701V88.4375C285.232 89.0715 285.399 89.5569 285.732 89.8937C286.066 90.2107 286.528 90.3692 287.117 90.3692C287.863 90.3692 288.55 90.1612 289.179 89.7451V92.8061C288.491 93.1429 287.608 93.3113 286.528 93.3113C283.307 93.3113 281.697 91.6669 281.697 88.378V80.7701H279.459V78.0954H281.697V74.4697H285.232V78.0954H288.943V80.7701H285.232Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.245 92.8659L290.354 78.0957H294.271L296.009 82.9101C296.539 84.3366 296.962 85.5353 297.276 86.5061C297.61 87.4769 297.816 88.0911 297.894 88.3486L297.983 88.7647C298.179 88.0713 298.807 86.1197 299.868 82.9101L301.429 78.0957H305.14L299.75 92.747C298.258 96.7689 295.98 98.7799 292.917 98.7799C292.347 98.7799 291.856 98.7303 291.444 98.6313V95.6891C291.758 95.7684 292.092 95.808 292.445 95.808C294.232 95.808 295.499 94.8273 296.245 92.8659Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.729 86.3814C317.768 87.8079 318.191 88.957 318.996 89.8288C319.82 90.7005 320.93 91.1364 322.324 91.1364C323.542 91.1364 324.671 90.7996 325.711 90.126V93.2167C324.671 93.8309 323.375 94.138 321.823 94.138C319.526 94.138 317.66 93.4049 316.227 91.9388C314.813 90.4727 314.106 88.6202 314.106 86.3814C314.126 84.1823 314.833 82.3298 316.227 80.824C317.641 79.3183 319.565 78.5654 322 78.5654C323.453 78.5654 324.69 78.8428 325.711 79.3976V82.5477C324.73 81.9137 323.61 81.5967 322.354 81.5967C320.979 81.5967 319.87 82.0326 319.025 82.9043C318.181 83.7761 317.749 84.9351 317.729 86.3814Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.365 87.3913H334.539C333.616 87.3913 332.909 87.5894 332.419 87.9857C331.928 88.3621 331.682 88.8475 331.682 89.4419C331.682 90.7099 332.409 91.3439 333.862 91.3439C334.647 91.3439 335.256 91.116 335.688 90.6604C336.14 90.1849 336.365 89.5707 336.365 88.8178V87.3913ZM329.12 82.8741V79.5753C330.239 78.8819 331.849 78.5352 333.95 78.5352C337.995 78.5352 340.018 80.4371 340.018 84.2411V93.87H336.513V92.0571C335.825 93.3449 334.529 93.9888 332.625 93.9888C331.211 93.9888 330.082 93.5728 329.237 92.7407C328.413 91.9085 328 90.8585 328 89.5905C328 88.164 328.531 87.0446 329.591 86.2323C330.651 85.42 332.183 85.0138 334.186 85.0138H336.365V84.0925C336.365 83.2604 336.149 82.6264 335.717 82.1905C335.285 81.7547 334.549 81.5367 333.508 81.5367C331.918 81.5367 330.455 81.9825 329.12 82.8741Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.201 78.8034V81.4781C347.888 79.6158 349.145 78.6846 350.971 78.6846C351.383 78.6846 351.717 78.7143 351.972 78.7737V82.2211C351.521 82.023 351.02 81.9239 350.47 81.9239C349.508 81.9239 348.722 82.3202 348.114 83.1126C347.505 83.9051 347.201 84.8958 347.201 86.0845V93.8708H343.637L343.666 78.8034H347.201Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.471 91.0175C361.531 91.0175 362.415 90.6113 363.121 89.799C363.828 88.9669 364.182 87.7682 364.182 86.203C364.182 84.6775 363.809 83.5383 363.063 82.7854C362.316 82.0127 361.462 81.6264 360.5 81.6264C359.479 81.6264 358.615 82.0523 357.908 82.9043C357.221 83.7364 356.877 84.9053 356.877 86.4111C356.877 87.7781 357.221 88.8876 357.908 89.7395C358.595 90.5915 359.449 91.0175 360.471 91.0175ZM364.182 72.8594H367.716V93.8704H364.182V91.5227C363.161 93.2265 361.649 94.0785 359.646 94.0785C357.682 94.0785 356.121 93.3256 354.963 91.8199C353.824 90.3141 353.254 88.4914 353.254 86.3516C353.254 83.9741 353.853 82.092 355.051 80.7051C356.268 79.2984 357.82 78.5951 359.705 78.5951C361.649 78.5951 363.141 79.4371 364.182 81.1212V72.8594Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_1511_63679)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M229.717 213.047V194.96H239.9V211.092H242.528V186.846L250.795 179.464V189.735H253.916V205.324H257.858V196.256H267.494V219.535H271.436V190.365L275.597 194.08V201.857H278.773V177.373L281.291 174.831V170.712H284.467V174.44L286.766 176.688V213.256H289.394V185.868L297.99 193.543V210.258H302.206V201.609L304.505 199.555V194.276L307.024 192.027V186.65H314.032V205.626H316.331V199.262L319.561 196.378V172.033H331.223V201.218H334.508V185.575L340.202 180.491V209.039H344.801V197.502L350.221 192.663V172.793H356.518V203.405H359.803V194.648H361.226V181.175H365.497V194.746H367.249V216.147H371.629V202.488L376.228 204.444V209.137H378.965V193.201H385.426V220.43H388.054V203.173H391.339V198.089L400.263 190.121V212.656H438",
    stroke: "#78A2E7",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.717 194.96L224.833 199.321V213.047",
    stroke: "#78A2E7",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.795 179.464L253.916 181.883V189.734",
    stroke: "#78A2E7",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.858 196.256L255.318 198.524V218.844",
    stroke: "#78A2E7",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.494 198.292H261.886",
    stroke: "#78A2E7",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.494 200.074H261.886",
    stroke: "#78A2E7",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.494 201.856H261.886",
    stroke: "#78A2E7",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.494 203.641H261.886",
    stroke: "#78A2E7",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.494 205.423H261.886",
    stroke: "#78A2E7",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.494 207.206H261.886",
    stroke: "#78A2E7",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.494 208.988H261.886",
    stroke: "#78A2E7",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.494 210.771H261.886",
    stroke: "#78A2E7",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.291 174.831V198.641",
    stroke: "#78A2E7",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.436 190.365L266.992 194.334V196.256",
    stroke: "#78A2E7",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.209 194.96V218.844",
    stroke: "#78A2E7",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.965 194.96V210.77",
    stroke: "#78A2E7",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.72 194.96V210.77",
    stroke: "#78A2E7",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.773 201.856V216.119",
    stroke: "#78A2E7",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.597 201.856V209.417",
    stroke: "#78A2E7",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.032 186.65L317.768 189.986V197.98",
    stroke: "#78A2E7",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.505 199.556V219.957",
    stroke: "#78A2E7",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.024 192.027V202.363",
    stroke: "#78A2E7",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.99 193.543L289.394 201.218",
    stroke: "#78A2E7",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.223 172.033L335.711 176.04V184.503",
    stroke: "#78A2E7",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.202 180.49L345.917 185.593V196.506",
    stroke: "#78A2E7",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.518 172.793L359.055 175.058V184.502",
    stroke: "#78A2E7",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.497 181.175L373.862 188.644V203.439",
    stroke: "#78A2E7",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.426 193.2L388.667 196.094V203.173",
    stroke: "#78A2E7",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.263 190.121L406.359 195.564V212.657",
    stroke: "#78A2E7",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.562 196.378V212.656",
    stroke: "#78A2E7",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.032 205.626V212.656",
    stroke: "#78A2E7",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.223 201.218V209.418",
    stroke: "#78A2E7",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.226 194.648V213.426",
    stroke: "#78A2E7",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.518 203.404V209.756",
    stroke: "#78A2E7",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 213.047H29.4489V203.954H34.0479V195.057L40.0157 189.729H53.2104V213.047H56.4954V197.078H66.1314V203.368H61.7514V179.805H72.2634V222.779H78.0669V202.781L82.5564 198.186V171.923L107.303 154.391V207.66H102.923V187.334H114.092V199.164H119.677V165.221H132.379V202.919H127.123V184.401H143.219V194.275H148.256V216.499H144.455V200.043H152.855V179.697L156.797 176.177V168.454L165.886 163.09V201.314H175.516V212.066H171.251V190.755L180.942 182.103V222.779H184.939V178.313L191.18 172.74H200.597L206.401 178.117V217.197H209.905V197.404H219.431V213.047H224.833",
    stroke: "#78A2E7",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.303 154.391L115.077 161.331V183.577",
    stroke: "#78A2E7",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.379 165.222L137.959 170.204V184.401",
    stroke: "#78A2E7",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.886 163.09L172.315 168.831V189.513",
    stroke: "#78A2E7",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.597 172.739V229.341",
    stroke: "#78A2E7",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.18 172.739V216.627",
    stroke: "#78A2E7",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.431 197.403L224.833 202.226V219.573",
    stroke: "#78A2E7",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.2634 187.254L79.5441 193.755V201.04",
    stroke: "#78A2E7",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.2634 179.806L77.3957 184.389V191.837",
    stroke: "#78A2E7",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.0156 189.729V219.149",
    stroke: "#78A2E7",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.4489 203.954L25.3383 207.624V217.016",
    stroke: "#78A2E7",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.7514 179.806L57.6079 183.506V197.078",
    stroke: "#78A2E7",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.5564 177.464L107.303 159.932",
    stroke: "#78A2E7",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.5564 183.578L107.303 166.045",
    stroke: "#78A2E7",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.5564 189.69L107.303 172.157",
    stroke: "#78A2E7",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.5564 195.802L107.303 178.27",
    stroke: "#78A2E7",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.5564 201.915C82.5564 201.915 93.3761 194.25 100.707 189.056",
    stroke: "#78A2E7",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.5564 208.027C82.5564 208.027 93.3597 200.373 100.691 195.18",
    stroke: "#78A2E7",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.5564 214.14C82.5564 214.14 93.2951 206.531 100.625 201.338",
    stroke: "#78A2E7",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.5564 220.251C82.5564 220.251 91.9833 213.572 99.2004 208.459",
    stroke: "#78A2E7",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.092 187.334L117.807 190.651V208.416",
    stroke: "#78A2E7",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.123 184.4L123.228 187.878V212.066",
    stroke: "#78A2E7",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.219 184.4L146.068 186.944V194.147",
    stroke: "#78A2E7",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.797 176.178V207.175",
    stroke: "#78A2E7",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.677 168.699H132.379",
    stroke: "#78A2E7",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.677 171.474H132.379",
    stroke: "#78A2E7",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.677 174.248H132.379",
    stroke: "#78A2E7",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.677 177.023H132.379",
    stroke: "#78A2E7",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.677 179.798H132.379",
    stroke: "#78A2E7",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.677 182.572H132.379",
    stroke: "#78A2E7",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.8394 189.729L40.0156 194.147",
    stroke: "#78A2E7",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.2104 190.211L40.5007 197.388",
    stroke: "#78A2E7",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.2104 194.342L40.5007 201.519",
    stroke: "#78A2E7",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.2104 198.473L40.5007 205.65",
    stroke: "#78A2E7",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.2104 202.603L40.5007 209.78",
    stroke: "#78A2E7",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.2104 206.734L40.5007 213.912",
    stroke: "#78A2E7",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.449 206.192H34.2659",
    stroke: "#78A2E7",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.449 208.027H34.2659",
    stroke: "#78A2E7",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.449 209.862H34.2659",
    stroke: "#78A2E7",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.886 166.24L172.315 171.98",
    stroke: "#78A2E7",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.886 170.438L172.315 176.177",
    stroke: "#78A2E7",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.886 174.635L172.315 180.375",
    stroke: "#78A2E7",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.886 178.832L172.315 184.572",
    stroke: "#78A2E7",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.886 183.029L172.315 188.769",
    stroke: "#78A2E7",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.896 167.508V198.765",
    stroke: "#78A2E7",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.285 165.911V197.169",
    stroke: "#78A2E7",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.673 164.315V195.573",
    stroke: "#78A2E7",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.123 202.919V220.251",
    stroke: "#78A2E7",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.379 202.919V213.912",
    stroke: "#78A2E7",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.123 194.342H132.379",
    stroke: "#78A2E7",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.751 184.4V202.919",
    stroke: "#78A2E7",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.959 173.307L142.588 177.44V184.571",
    stroke: "#78A2E7",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.923 187.334L107.107 191.07",
    stroke: "#78A2E7",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.923 191.069L107.107 194.805",
    stroke: "#78A2E7",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.923 194.805L107.107 198.54",
    stroke: "#78A2E7",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.923 198.541L107.107 202.277",
    stroke: "#78A2E7",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.923 202.276L107.107 206.011",
    stroke: "#78A2E7",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.766 197.471V222.779",
    stroke: "#78A2E7",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.144 197.471V222.779",
    stroke: "#78A2E7",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.942 182.103L183.374 186.279V229.999",
    stroke: "#78A2E7",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1511_63679"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 424,
    height: 212,
    rx: 20,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1511_63679"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 324,
    height: 70.7586,
    fill: "white",
    transform: "translate(50 50)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_1511_63679"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 438,
    height: 76,
    fill: "white",
    transform: "translate(0 154)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMypropertlogo);
export default __webpack_public_path__ + "static/media/mypropertlogo.276046944343a3582f7eba780ecfeaa8.svg";
export { ForwardRef as ReactComponent };